export default __webpack_public_path__ + "static/media/MainMeterECActive.7676e843.svg";